/**
 * Customer Portal API
 * See `api-description.md` for detailed description.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { EnergyPrice } from '../model/energyPrice';
// @ts-ignore
import { EnergyType } from '../model/energyType';
// @ts-ignore
import { Resolution } from '../model/resolution';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';



@Injectable({
  providedIn: 'root'
})
export class EnergyPriceService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substr(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Get energy prices for a specified time period and resolution
     * @param energyType Energy type
     * @param startDateTime Energy price period beginning date and time (i.e. &#x60;2021-12-31T22:00:00.000Z&#x60;).
     * @param endDateTime Energy price period end date and time (i.e. &#x60;2022-12-31T21:59:59.999Z&#x60;).
     * @param resolution Resolution for the energy price period.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEnergyPrice(energyType: EnergyType, startDateTime: string, endDateTime: string, resolution: Resolution, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<EnergyPrice>>;
    public getEnergyPrice(energyType: EnergyType, startDateTime: string, endDateTime: string, resolution: Resolution, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<EnergyPrice>>>;
    public getEnergyPrice(energyType: EnergyType, startDateTime: string, endDateTime: string, resolution: Resolution, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<EnergyPrice>>>;
    public getEnergyPrice(energyType: EnergyType, startDateTime: string, endDateTime: string, resolution: Resolution, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (energyType === null || energyType === undefined) {
            throw new Error('Required parameter energyType was null or undefined when calling getEnergyPrice.');
        }
        if (startDateTime === null || startDateTime === undefined) {
            throw new Error('Required parameter startDateTime was null or undefined when calling getEnergyPrice.');
        }
        if (endDateTime === null || endDateTime === undefined) {
            throw new Error('Required parameter endDateTime was null or undefined when calling getEnergyPrice.');
        }
        if (resolution === null || resolution === undefined) {
            throw new Error('Required parameter resolution was null or undefined when calling getEnergyPrice.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (startDateTime !== undefined && startDateTime !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>startDateTime, 'startDateTime');
        }
        if (endDateTime !== undefined && endDateTime !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>endDateTime, 'endDateTime');
        }
        if (resolution !== undefined && resolution !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>resolution, 'resolution');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        return this.httpClient.get<Array<EnergyPrice>>(`${this.configuration.basePath}/api/public/v1/energy-price/${encodeURIComponent(String(energyType))}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get energy prices for a specified time period and resolution in CSV format
     * @param energyType Energy type
     * @param startDateTime Energy price period beginning date and time (i.e. &#x60;2021-12-31T22:00:00.000Z&#x60;).
     * @param endDateTime Energy price period end date and time (i.e. &#x60;2022-12-31T21:59:59.999Z&#x60;).
     * @param resolution Resolution for the energy price period.
     * @param withHeader Flag indicating whether or not to include header in the CSV
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEnergyPriceCsv(energyType: EnergyType, startDateTime: string, endDateTime: string, resolution: Resolution, withHeader?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/csv', context?: HttpContext}): Observable<string>;
    public getEnergyPriceCsv(energyType: EnergyType, startDateTime: string, endDateTime: string, resolution: Resolution, withHeader?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/csv', context?: HttpContext}): Observable<HttpResponse<string>>;
    public getEnergyPriceCsv(energyType: EnergyType, startDateTime: string, endDateTime: string, resolution: Resolution, withHeader?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/csv', context?: HttpContext}): Observable<HttpEvent<string>>;
    public getEnergyPriceCsv(energyType: EnergyType, startDateTime: string, endDateTime: string, resolution: Resolution, withHeader?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/csv', context?: HttpContext}): Observable<any> {
        if (energyType === null || energyType === undefined) {
            throw new Error('Required parameter energyType was null or undefined when calling getEnergyPriceCsv.');
        }
        if (startDateTime === null || startDateTime === undefined) {
            throw new Error('Required parameter startDateTime was null or undefined when calling getEnergyPriceCsv.');
        }
        if (endDateTime === null || endDateTime === undefined) {
            throw new Error('Required parameter endDateTime was null or undefined when calling getEnergyPriceCsv.');
        }
        if (resolution === null || resolution === undefined) {
            throw new Error('Required parameter resolution was null or undefined when calling getEnergyPriceCsv.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (startDateTime !== undefined && startDateTime !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>startDateTime, 'startDateTime');
        }
        if (endDateTime !== undefined && endDateTime !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>endDateTime, 'endDateTime');
        }
        if (resolution !== undefined && resolution !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>resolution, 'resolution');
        }
        if (withHeader !== undefined && withHeader !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>withHeader, 'withHeader');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'text/csv'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        return this.httpClient.get<string>(`${this.configuration.basePath}/api/public/v1/energy-price/${encodeURIComponent(String(energyType))}/csv`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
